// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class UserUpdateResource extends Resource {
    basePath: string = 'authorisation/users-update';

    objectPath: string = 'authorisation/users-update/{ident}/';
}
